/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ApplicationPermissions } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import type { ProductName } from '@atlassian/jira-shared-types/src/product-name.tsx';

export const getProductName = (permissions: ApplicationPermissions): ProductName => {
	const {
		hasSoftwareAccess,
		hasServiceDeskAccess,
		hasCustomerServiceAccess,
		hasCoreAccess,
		hasProductDiscoveryAccess,
	} = permissions;

	// @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
	return (
		[
			{
				condition:
					hasSoftwareAccess &&
					!hasServiceDeskAccess &&
					!hasProductDiscoveryAccess &&
					!hasCustomerServiceAccess,
				value: 'software',
			},
			{
				condition:
					hasServiceDeskAccess &&
					!hasSoftwareAccess &&
					!hasProductDiscoveryAccess &&
					!hasCustomerServiceAccess,
				value: 'serviceDesk',
			},
			{
				condition:
					hasServiceDeskAccess &&
					hasCustomerServiceAccess &&
					!hasSoftwareAccess &&
					!hasProductDiscoveryAccess,
				value: 'serviceDesk',
			},
			{
				condition:
					hasCoreAccess &&
					!hasSoftwareAccess &&
					!hasServiceDeskAccess &&
					!hasProductDiscoveryAccess &&
					!hasCustomerServiceAccess,
				value: 'core',
			},
			{
				condition:
					hasProductDiscoveryAccess &&
					!hasSoftwareAccess &&
					!hasServiceDeskAccess &&
					!hasCustomerServiceAccess,
				value: 'product-discovery',
			},
			{
				condition:
					hasCustomerServiceAccess &&
					!hasProductDiscoveryAccess &&
					!hasSoftwareAccess &&
					!hasServiceDeskAccess,
				value: 'customer-service',
			},
		].find((item) => item.condition) || { value: 'jira' }
	).value;
};
